export class LocalStorageVales
{

public static getSession(){
    let session=localStorage.getItem('session');
    return session;
}

}